import { Box, Text } from '@chakra-ui/react';
import {  RiPhoneFill } from 'react-icons/ri';
import React from 'react';

const ContactPhone = ({phone}) => {
  if(typeof phone === 'undefined'  || phone === '') {
    return null;
  }
  return (
    <Box className='linkWrapper' >
      <Text className='linkText' ><RiPhoneFill />  </Text><Text >{phone}</Text></Box>
  );
}
export default ContactPhone;